import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ToastModule } from 'src/app/core/toast/toast.module';

import { SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { SidebarModuleCustom } from '../sidebar/sidebar.module';
import { StatusbarModule } from 'src/app/core/statusbar/statusbar.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ErrorModule } from 'src/app/core/error/error.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';



@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    HeaderModule,
    FooterModule,
    SidebarModule,
    SidebarModuleCustom,
    StatusbarModule,
    ToastModule,
    DashboardModule,
    ErrorModule,
    TranslateModule,

  ],
  providers:[
    TranslatePipe
  ]
})
export class HomeModule { }
